// Cross-links between the site's ~18 near-duplicate keyword-modifier landing
// pages, which previously had zero internal links to each other or to any
// pillar (each page's only links were the fixed sitewide nav/footer). Each
// entry lists 3 related paths: two from the same topical cluster plus one
// "bridge" link into a different cluster, so the clusters aren't isolated
// silos (from an earlier SEO cluster audit).
//
// Anchor text here must match each target page's actual current H1 - it
// previously used the pre-rewrite generic "X to Increase Repeat Customers"
// titles verbatim, which drifted out of sync the moment any of the 18 pages
// got a real, differentiated H1 (an anchor promising one thing and landing
// on a page titled something else is both a bad user experience and a
// wasted anchor-text relevance signal).
export const relatedLandingPages: Record<
  string,
  { path: string; title: string }[]
> = {
  "/customer-loyalty-platform": [
    {
      path: "/free-customer-loyalty-app",
      title:
        "Download Free Customer Loyalty App to Increase Repeat Customers for Your Retail Businesses",
    },
    {
      path: "/customer-retention-platform-india",
      title: "Customer Retention Built the Way Indian Retail Actually Works",
    },
    {
      path: "/customer-loyalty-program",
      title:
        "Build a Complete Customer Loyalty Program for Your Retail Business - Rewards, WhatsApp Campaigns, and Reporting in One Place.",
    },
  ],
  "/customer-loyalty-program": [
    {
      path: "/customer-loyalty-platform",
      title: "One Loyalty Platform to Replace Every Tool You're Juggling Today",
    },
    {
      path: "/loyalty-program-for-retail-stores",
      title: "Design a Loyalty Program With Rules That Actually Fit Your Store",
    },
    {
      path: "/loyalty-program-software-for-retail",
      title:
        "Loyalty Program Software Built on a Dashboard, Automation, and Reports",
    },
  ],
  "/free-customer-loyalty-app": [
    {
      path: "/customer-retention-platform-india",
      title: "Customer Retention Built the Way Indian Retail Actually Works",
    },
    {
      path: "/retail-customer-engagement-platform",
      title:
        "Stay Top of Mind Across WhatsApp, App, and In-Store - Not Just One Channel",
    },
    {
      path: "/loyalty-program-for-retail-stores",
      title: "Design a Loyalty Program With Rules That Actually Fit Your Store",
    },
  ],
  "/customer-retention-platform-india": [
    {
      path: "/retail-customer-engagement-platform",
      title:
        "Stay Top of Mind Across WhatsApp, App, and In-Store - Not Just One Channel",
    },
    {
      path: "/customer-loyalty-platform",
      title: "One Loyalty Platform to Replace Every Tool You're Juggling Today",
    },
    {
      path: "/loyalty-program-software-for-retail",
      title:
        "Loyalty Program Software Built on a Dashboard, Automation, and Reports",
    },
  ],
  "/retail-customer-engagement-platform": [
    {
      path: "/customer-loyalty-platform",
      title: "One Loyalty Platform to Replace Every Tool You're Juggling Today",
    },
    {
      path: "/free-customer-loyalty-app",
      title:
        "Download Free Customer Loyalty App to Increase Repeat Customers for Your Retail Businesses",
    },
    {
      path: "/loyalty-software-for-shop-owners",
      title: "Loyalty Software You Set Up Yourself - No IT Team, No Manual",
    },
  ],
  "/loyalty-program-for-retail-stores": [
    {
      path: "/loyalty-program-software-for-retail",
      title:
        "Loyalty Program Software Built on a Dashboard, Automation, and Reports",
    },
    {
      path: "/loyalty-software-for-shop-owners",
      title: "Loyalty Software You Set Up Yourself - No IT Team, No Manual",
    },
    {
      path: "/customer-loyalty-program",
      title:
        "Build a Complete Customer Loyalty Program for Your Retail Business - Rewards, WhatsApp Campaigns, and Reporting in One Place.",
    },
  ],
  "/loyalty-program-software-for-retail": [
    {
      path: "/loyalty-software-for-shop-owners",
      title: "Loyalty Software You Set Up Yourself - No IT Team, No Manual",
    },
    {
      path: "/loyalty-program-for-retail-stores",
      title: "Design a Loyalty Program With Rules That Actually Fit Your Store",
    },
    {
      path: "/customer-loyalty-program",
      title:
        "Build a Complete Customer Loyalty Program for Your Retail Business - Rewards, WhatsApp Campaigns, and Reporting in One Place.",
    },
  ],
  "/loyalty-software-for-shop-owners": [
    {
      path: "/loyalty-program-for-retail-stores",
      title: "Design a Loyalty Program With Rules That Actually Fit Your Store",
    },
    {
      path: "/loyalty-program-software-for-retail",
      title:
        "Loyalty Program Software Built on a Dashboard, Automation, and Reports",
    },
    {
      path: "/customer-retention-platform-india",
      title: "Customer Retention Built the Way Indian Retail Actually Works",
    },
  ],
  "/how-to-increase-repeat-customers": [
    {
      path: "/how-to-bring-customers-back-to-shop",
      title: "How to Bring Customers Back to Your Shop",
    },
    {
      path: "/increase-footfall-in-retail-store",
      title: "Increase Footfall in Your Retail Store with Local Offers",
    },
    {
      path: "/loyalty-program-for-grocery-store",
      title: "Loyalty Program for Grocery Stores to Build Daily Repeat Habits",
    },
  ],
  "/how-to-bring-customers-back-to-shop": [
    {
      path: "/increase-footfall-in-retail-store",
      title: "Increase Footfall in Your Retail Store with Local Offers",
    },
    {
      path: "/customer-retention-strategies-for-small-business",
      title: "Customer Retention Strategies for Small Businesses on a Budget",
    },
    {
      path: "/loyalty-app-for-clothing-store",
      title: "Bring Shoppers Back for Every New Collection, Not Just One Sale",
    },
  ],
  "/increase-footfall-in-retail-store": [
    {
      path: "/customer-retention-strategies-for-small-business",
      title: "Customer Retention Strategies for Small Businesses on a Budget",
    },
    {
      path: "/how-to-increase-repeat-customers",
      title: "How to Increase Repeat Customers for Your Retail Business",
    },
    {
      path: "/loyalty-software-for-salon",
      title: "Loyalty Software for Salons to Fill More Repeat Bookings",
    },
  ],
  "/customer-retention-strategies-for-small-business": [
    {
      path: "/how-to-increase-repeat-customers",
      title: "How to Increase Repeat Customers for Your Retail Business",
    },
    {
      path: "/how-to-bring-customers-back-to-shop",
      title: "How to Bring Customers Back to Your Shop",
    },
    {
      path: "/customer-retention-for-restaurants",
      title:
        "Turn First-Time Diners Into Regulars With Restaurant Loyalty Rewards",
    },
  ],
  "/loyalty-program-for-grocery-store": [
    {
      path: "/loyalty-app-for-clothing-store",
      title: "Bring Shoppers Back for Every New Collection, Not Just One Sale",
    },
    {
      path: "/loyalty-software-for-salon",
      title: "Loyalty Software for Salons to Fill More Repeat Bookings",
    },
    {
      path: "/how-to-increase-repeat-customers",
      title: "How to Increase Repeat Customers for Your Retail Business",
    },
  ],
  "/loyalty-app-for-clothing-store": [
    {
      path: "/loyalty-software-for-salon",
      title: "Loyalty Software for Salons to Fill More Repeat Bookings",
    },
    {
      path: "/customer-retention-for-restaurants",
      title:
        "Turn First-Time Diners Into Regulars With Restaurant Loyalty Rewards",
    },
    {
      path: "/how-to-bring-customers-back-to-shop",
      title: "How to Bring Customers Back to Your Shop",
    },
  ],
  "/loyalty-software-for-salon": [
    {
      path: "/customer-retention-for-restaurants",
      title:
        "Turn First-Time Diners Into Regulars With Restaurant Loyalty Rewards",
    },
    {
      path: "/loyalty-program-for-grocery-store",
      title: "Loyalty Program for Grocery Stores to Build Daily Repeat Habits",
    },
    {
      path: "/increase-footfall-in-retail-store",
      title: "Increase Footfall in Your Retail Store with Local Offers",
    },
  ],
  "/customer-retention-for-restaurants": [
    {
      path: "/loyalty-program-for-grocery-store",
      title: "Loyalty Program for Grocery Stores to Build Daily Repeat Habits",
    },
    {
      path: "/loyalty-app-for-clothing-store",
      title: "Bring Shoppers Back for Every New Collection, Not Just One Sale",
    },
    {
      path: "/customer-retention-strategies-for-small-business",
      title: "Customer Retention Strategies for Small Businesses on a Budget",
    },
  ],
  "/cashback-and-rewards-system-for-shops": [
    {
      path: "/whatsapp-marketing-for-retail-business",
      title: "Send WhatsApp Campaigns That Bring Customers Back to Your Shop",
    },
    {
      path: "/customer-analytics-for-retail",
      title: "Know Which Customers Come Back and Which Campaigns Actually Work",
    },
    {
      path: "/customer-loyalty-platform",
      title: "One Loyalty Platform to Replace Every Tool You're Juggling Today",
    },
  ],
  "/whatsapp-marketing-for-retail-business": [
    {
      path: "/customer-analytics-for-retail",
      title: "Know Which Customers Come Back and Which Campaigns Actually Work",
    },
    {
      path: "/cashback-and-rewards-system-for-shops",
      title: "Reward Customers With Cashback Instead of Flat Discounts",
    },
    {
      path: "/free-customer-loyalty-app",
      title:
        "Download Free Customer Loyalty App to Increase Repeat Customers for Your Retail Businesses",
    },
  ],
  "/customer-analytics-for-retail": [
    {
      path: "/cashback-and-rewards-system-for-shops",
      title: "Reward Customers With Cashback Instead of Flat Discounts",
    },
    {
      path: "/whatsapp-marketing-for-retail-business",
      title: "Send WhatsApp Campaigns That Bring Customers Back to Your Shop",
    },
    {
      path: "/retail-customer-engagement-platform",
      title:
        "Stay Top of Mind Across WhatsApp, App, and In-Store - Not Just One Channel",
    },
  ],
  // The 11-page "reward mechanic" and "retention operations" batch below
  // (cashback / points / stamp card / coupons / platform / referral /
  // program-selection / personalization / retention-software /
  // retention-management) cross-links within itself first, then bridges out
  // to one relevant page from the original cluster above, so the new batch
  // isn't an isolated silo the way the original ~18 pages were before this
  // file existed.
  "/cashback-loyalty-program": [
    {
      path: "/loyalty-points-software",
      title: "Loyalty Points Software to Increase Repeat Customers & Sales",
    },
    {
      path: "/customer-rewards-platform",
      title: "Customer Rewards Platform to Increase Repeat Customers & Sales",
    },
    {
      path: "/cashback-and-rewards-system-for-shops",
      title: "Reward Customers With Cashback Instead of Flat Discounts",
    },
  ],
  "/loyalty-points-software": [
    {
      path: "/cashback-loyalty-program",
      title: "Cashback Loyalty Program to Increase Repeat Customers & Sales",
    },
    {
      path: "/digital-stamp-card",
      title: "Digital Stamp Card to Increase Repeat Customers & Sales",
    },
    {
      path: "/customer-rewards-platform",
      title: "Customer Rewards Platform to Increase Repeat Customers & Sales",
    },
  ],
  "/digital-loyalty-program": [
    {
      path: "/digital-stamp-card",
      title: "Digital Stamp Card to Increase Repeat Customers & Sales",
    },
    {
      path: "/personalized-loyalty-program",
      title:
        "Personalized Loyalty Program to Increase Repeat Customers & Sales",
    },
    {
      path: "/customer-loyalty-platform",
      title: "One Loyalty Platform to Replace Every Tool You're Juggling Today",
    },
  ],
  "/digital-stamp-card": [
    {
      path: "/loyalty-points-software",
      title: "Loyalty Points Software to Increase Repeat Customers & Sales",
    },
    {
      path: "/digital-loyalty-program",
      title: "Digital Loyalty Program to Increase Repeat Customers & Sales",
    },
    {
      path: "/cashback-loyalty-program",
      title: "Cashback Loyalty Program to Increase Repeat Customers & Sales",
    },
  ],
  "/coupon-loyalty-program": [
    {
      path: "/personalized-loyalty-program",
      title:
        "Personalized Loyalty Program to Increase Repeat Customers & Sales",
    },
    {
      path: "/customer-rewards-platform",
      title: "Customer Rewards Platform to Increase Repeat Customers & Sales",
    },
    {
      path: "/cashback-and-rewards-system-for-shops",
      title: "Reward Customers With Cashback Instead of Flat Discounts",
    },
  ],
  "/customer-rewards-platform": [
    {
      path: "/customer-reward-program",
      title: "Customer Reward Program to Increase Repeat Customers & Sales",
    },
    {
      path: "/cashback-loyalty-program",
      title: "Cashback Loyalty Program to Increase Repeat Customers & Sales",
    },
    {
      path: "/loyalty-points-software",
      title: "Loyalty Points Software to Increase Repeat Customers & Sales",
    },
  ],
  "/referral-rewards-software": [
    {
      path: "/customer-retention-management",
      title:
        "Customer Retention Management to Increase Repeat Customers & Sales",
    },
    {
      path: "/personalized-loyalty-program",
      title:
        "Personalized Loyalty Program to Increase Repeat Customers & Sales",
    },
    {
      path: "/whatsapp-marketing-for-retail-business",
      title: "Send WhatsApp Campaigns That Bring Customers Back to Your Shop",
    },
  ],
  "/customer-reward-program": [
    {
      path: "/customer-rewards-platform",
      title: "Customer Rewards Platform to Increase Repeat Customers & Sales",
    },
    {
      path: "/personalized-loyalty-program",
      title:
        "Personalized Loyalty Program to Increase Repeat Customers & Sales",
    },
    {
      path: "/customer-loyalty-program",
      title:
        "Build a Complete Customer Loyalty Program for Your Retail Business - Rewards, WhatsApp Campaigns, and Reporting in One Place.",
    },
  ],
  "/personalized-loyalty-program": [
    {
      path: "/customer-reward-program",
      title: "Customer Reward Program to Increase Repeat Customers & Sales",
    },
    {
      path: "/customer-retention-software",
      title: "Customer Retention Software to Increase Repeat Customers & Sales",
    },
    {
      path: "/coupon-loyalty-program",
      title: "Coupon Loyalty Program to Increase Repeat Customers & Sales",
    },
  ],
  "/customer-retention-software": [
    {
      path: "/customer-retention-management",
      title:
        "Customer Retention Management to Increase Repeat Customers & Sales",
    },
    {
      path: "/personalized-loyalty-program",
      title:
        "Personalized Loyalty Program to Increase Repeat Customers & Sales",
    },
    {
      path: "/customer-retention-platform-india",
      title: "Customer Retention Built the Way Indian Retail Actually Works",
    },
  ],
  "/customer-retention-management": [
    {
      path: "/customer-retention-software",
      title: "Customer Retention Software to Increase Repeat Customers & Sales",
    },
    {
      path: "/referral-rewards-software",
      title: "Referral Rewards Software to Increase Customers & Repeat Sales",
    },
    {
      path: "/customer-retention-strategies-for-small-business",
      title: "Customer Retention Strategies for Small Businesses on a Budget",
    },
  ],
  // Keyword pages -> the Website 2.0 pages that go deeper on the same
  // topic (anchor text = the target's H1).
  "/customer-reactivation-software": [
    { path: "/customer-win-back-software", title: "Bring back the customers who went quiet" },
    { path: "/how-to-segment-customers", title: "How to segment your customers" },
    { path: "/customer-analytics-for-retail", title: "Know who your customers are, and who is slipping away" },
  ],
  "/customer-churn-reduction": [
    { path: "/customer-win-back-software", title: "Bring back the customers who went quiet" },
    { path: "/customer-analytics-for-retail", title: "Know who your customers are, and who is slipping away" },
    { path: "/how-to-segment-customers", title: "How to segment your customers" },
  ],
  "/customer-reengagement-software": [
    { path: "/customer-win-back-software", title: "Bring back the customers who went quiet" },
    { path: "/customer-engagement-campaigns", title: "Campaigns that bring the right customers back" },
    { path: "/how-to-create-a-whatsapp-campaign", title: "How to create a WhatsApp campaign" },
  ],
  "/repeat-purchase-software": [
    { path: "/how-to-increase-repeat-purchases", title: "How to increase repeat purchases" },
    { path: "/cashback-loyalty-program", title: "Turn Every Purchase into a Reason to Return" },
    { path: "/customer-engagement-campaigns", title: "Campaigns that bring the right customers back" },
  ],
  "/repeat-customer-platform": [
    { path: "/how-to-increase-repeat-purchases", title: "How to increase repeat purchases" },
    { path: "/cashback-loyalty-program", title: "Turn Every Purchase into a Reason to Return" },
    { path: "/customer-analytics-for-retail", title: "Know who your customers are, and who is slipping away" },
  ],
  "/automated-loyalty-campaigns": [
    { path: "/customer-engagement-campaigns", title: "Campaigns that bring the right customers back" },
    { path: "/whatsapp-loyalty-marketing", title: "Talk to customers where they already are" },
    { path: "/how-to-create-a-whatsapp-campaign", title: "How to create a WhatsApp campaign" },
  ],
  "/customer-engagement-software": [
    { path: "/customer-engagement-campaigns", title: "Campaigns that bring the right customers back" },
    { path: "/whatsapp-loyalty-marketing", title: "Talk to customers where they already are" },
    { path: "/how-to-segment-customers", title: "How to segment your customers" },
  ],
  "/loyalty-marketing-software": [
    { path: "/customer-engagement-campaigns", title: "Campaigns that bring the right customers back" },
    { path: "/whatsapp-loyalty-marketing", title: "Talk to customers where they already are" },
    { path: "/how-to-plan-a-loyalty-program", title: "How to plan your first loyalty programme" },
  ],
  "/loyalty-app-for-businesses": [
    { path: "/how-to-plan-a-loyalty-program", title: "How to plan your first loyalty programme" },
    { path: "/qr-code-loyalty-program", title: "However your customer pays, their loyalty journey continues" },
    { path: "/cashback-loyalty-program", title: "Turn Every Purchase into a Reason to Return" },
  ],
  "/loyalty-software-with-pos-integration": [
    { path: "/pos-loyalty-integration", title: "Start without integration. Connect when you are ready." },
    { path: "/how-to-record-a-bill-with-fydo", title: "How to record a bill at the counter" },
    { path: "/qr-code-loyalty-program", title: "However your customer pays, their loyalty journey continues" },
  ],
  "/digital-loyalty-card": [
    { path: "/qr-code-loyalty-program", title: "However your customer pays, their loyalty journey continues" },
    { path: "/how-to-plan-a-loyalty-program", title: "How to plan your first loyalty programme" },
    { path: "/cashback-loyalty-program", title: "Turn Every Purchase into a Reason to Return" },
  ],
  "/loyalty-program-for-retail": [
    { path: "/how-to-plan-a-loyalty-program", title: "How to plan your first loyalty programme" },
    { path: "/loyalty-program-for-grocery-store", title: "Reward regular shoppers in a way a small shop can afford" },
    { path: "/loyalty-app-for-clothing-store", title: "Turn a first purchase into a second one" },
  ],
  "/loyalty-program-for-supermarket": [
    { path: "/loyalty-program-for-grocery-store", title: "Reward regular shoppers in a way a small shop can afford" },
    { path: "/loyalty-program-for-multi-location-businesses", title: "One loyalty program, many locations" },
    { path: "/how-to-record-a-bill-with-fydo", title: "How to record a bill at the counter" },
  ],
  "/loyalty-program-for-footwear-store": [
    { path: "/loyalty-app-for-clothing-store", title: "Turn a first purchase into a second one" },
    { path: "/discount-loyalty-program", title: "Discounts customers see on the bill" },
    { path: "/how-to-increase-repeat-purchases", title: "How to increase repeat purchases" },
  ],
  "/loyalty-program-for-electronics-store": [
    { path: "/loyalty-program-for-jewellery-store", title: "Be remembered between weddings and festivals" },
    { path: "/discount-loyalty-program", title: "Discounts customers see on the bill" },
    { path: "/loyalty-program-for-multi-location-businesses", title: "One loyalty program, many locations" },
  ],
  "/loyalty-program-for-furniture-store": [
    { path: "/loyalty-program-for-jewellery-store", title: "Be remembered between weddings and festivals" },
    { path: "/discount-loyalty-program", title: "Discounts customers see on the bill" },
    { path: "/how-to-increase-repeat-purchases", title: "How to increase repeat purchases" },
  ],
  "/loyalty-program-for-pharmacy": [
    { path: "/loyalty-program-for-grocery-store", title: "Reward regular shoppers in a way a small shop can afford" },
    { path: "/loyalty-program-for-multi-location-businesses", title: "One loyalty program, many locations" },
    { path: "/whatsapp-loyalty-marketing", title: "Talk to customers where they already are" },
  ],
  "/loyalty-program-for-medical-store": [
    { path: "/loyalty-program-for-grocery-store", title: "Reward regular shoppers in a way a small shop can afford" },
    { path: "/whatsapp-loyalty-marketing", title: "Talk to customers where they already are" },
    { path: "/how-to-record-a-bill-with-fydo", title: "How to record a bill at the counter" },
  ],
  "/loyalty-program-for-optical-store": [
    { path: "/customer-analytics-for-retail", title: "Know who your customers are, and who is slipping away" },
    { path: "/whatsapp-loyalty-marketing", title: "Talk to customers where they already are" },
    { path: "/how-to-plan-a-loyalty-program", title: "How to plan your first loyalty programme" },
  ],
  "/loyalty-program-for-cosmetics-store": [
    { path: "/loyalty-program-for-spas", title: "Make every treatment the start of a routine" },
    { path: "/loyalty-app-for-clothing-store", title: "Turn a first purchase into a second one" },
    { path: "/whatsapp-loyalty-marketing", title: "Talk to customers where they already are" },
  ],
  "/loyalty-program-for-sports-store": [
    { path: "/loyalty-program-for-gyms", title: "Reward the members who keep showing up" },
    { path: "/loyalty-app-for-clothing-store", title: "Turn a first purchase into a second one" },
    { path: "/discount-loyalty-program", title: "Discounts customers see on the bill" },
  ],
  "/loyalty-program-for-mobile-store": [
    { path: "/discount-loyalty-program", title: "Discounts customers see on the bill" },
    { path: "/cashback-loyalty-program", title: "Turn Every Purchase into a Reason to Return" },
    { path: "/whatsapp-loyalty-marketing", title: "Talk to customers where they already are" },
  ],
  "/loyalty-program-for-hardware-store": [
    { path: "/loyalty-program-for-multi-location-businesses", title: "One loyalty program, many locations" },
    { path: "/cashback-loyalty-program", title: "Turn Every Purchase into a Reason to Return" },
    { path: "/how-to-record-a-bill-with-fydo", title: "How to record a bill at the counter" },
  ],
};
